module.exports = __webpack_public_path__ + "img/yallow.cc2cf1d7.png";